<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">服务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">提交工单</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="se-panel-title">提交工单</div>
      </div>
      <div class="panel-body">
        <div class="step-bar-quadra step-bar-outer clearfix z-textAlign-center z-margin-bottom-25-precent">
          <div :class="{'step--current':steps === 'first'}" class="step-bar step-bar-begin">
            <div class="step-colored">
							<span>
								① 选择问题所属类别
							</span>
            </div>
            <span class="step-arrow-right"></span>
          </div>
          <div :class="{'step--current':steps === 'second'}" class="step-bar step-bar-center">
            <span class="step-arrow-left"></span>
            <div class="step-colored">
							<span>
								② 选择问题类型
							</span>
            </div>
            <span class="step-arrow-right"></span>
          </div>
          <div :class="{'step--current':steps === 'three'}" class="step-bar step-bar-center">
            <span class="step-arrow-left"></span>
            <div class="step-colored">
							<span>
								③ 推荐解决方案
							</span>
            </div>
            <span class="step-arrow-right"></span>
          </div>
          <div :class="{'step--current':steps === 'four'}" class="step-bar step-bar-end">
            <span class="step-arrow-left"></span>
            <div class="step-colored">
							<span>
								④ 创建工单
							</span>
            </div>
          </div>
        </div>
        <div v-show="steps === 'first'">
          <el-input placeholder="输入问题描述或产品名称进行搜索" v-model="search" class="z-margin-bottom-10-precent" @keyup.enter.native="SearchQuery" style="width:420px">
            <el-button slot="append" icon="el-icon-search" @click="SearchQuery"></el-button>
          </el-input>
          <div class="select-container-wrapper">
            <div class="select-container">
              <p class="select-container-title">
                问题所属类别
              </p>
              <div class="select-item-wrapper clearfix">
                <div class="select-item" @click="SelectHelp(247)">
                  <div class="select-item-icon select-item-icon01"></div>
                  <p class="select-item-title">
                    云服务器
                  </p>
                  <p class="select-item-intro text-overflow" title="解决云服务器启动、联网、远程故障问题">
                    解决云服务器启动、联网、远程故障问题
                  </p>
                </div>
                <div class="select-item" @click="SelectHelp(111)">
                  <div class="select-item-icon select-item-icon02"></div>
                  <p class="select-item-title">
                    网站备案
                  </p>
                  <p class="select-item-intro text-overflow" title="咨询域名备案相关问题">
                    咨询域名备案相关问题
                  </p>
                </div>
                <div class="select-item" @click="SelectHelp(144)">
                  <div class="select-item-icon select-item-icon03"></div>
                  <p class="select-item-title">
                    域名
                  </p>
                  <p class="select-item-intro text-overflow" title="解决域名解析故障">
                    解决域名解析故障
                  </p>
                </div>
                <div class="select-item" @click="SelectHelp(244)">
                  <div class="select-item-icon select-item-icon03"></div>
                  <p class="select-item-title">
                    虚拟主机
                  </p>
                  <p class="select-item-intro text-overflow" title="协助解决虚拟主机域名绑定、设置等相关问题">
                    协助解决虚拟主机域名绑定、设置等相关问题
                  </p>
                </div>
                <div class="select-item" @click="SelectHelp(240)">
                  <div class="select-item-icon select-item-icon03"></div>
                  <p class="select-item-title">
                    账号与财务
                  </p>
                  <p class="select-item-intro text-overflow" title="咨询账号充值、产品购买信息">
                    咨询账号充值、产品购买信息
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="steps === 'second' || steps === 'three'">
          <div class="alert-warn">
            请选择您遇到的问题类型
          </div>
          <div class="ub-box">
            <div class="menu-box ">
              <div class="menu-box-title">
                网络类分类
              </div>
              <ul class="fuwu-menu-list">
                <li class="fuwu-menu-item" :class="{'menu-active': index == menuIndex}" v-for="(item,index) in typeList">
                  <a href="javascript:;" @click="SelectQuery(item.id,index)" :title="item.title">{{item.title}}</a>
                  <i></i>
                </li>

              </ul>
            </div>
            <div class="content-box">
              <div class="content-box-inner">
                <div class="search-box">
                  <el-input placeholder="输入问题描述或产品名称进行搜索" v-model="search" class="z-margin-bottom-10-precent" @keyup.enter.native="SearchQuery" style="width:420px">
                    <el-button slot="append" icon="el-icon-search" @click="SearchQuery"></el-button>
                  </el-input>
                  <ul class="fuzzy-query" style="display: none;"></ul>
                </div>

                <div v-show="selquestion === 'index'" class="index-box">
                  <div class="index-panel">
                    <p>请您在左侧选择对应您问题的分类查找答案或提交工单</p>
                    <p>不同的分类对应不同工程师，请正确选择！</p>
                  </div>
                </div>

                <div v-show="selquestion === 'question'" class="question-box">
                  <div class="question-tip">三丰云向您推荐 <span class="z-color-66-orange z-font-size-14">{{total}}</span> 条热点问题，以下可能包含您遇到的问题：</div>
                  <div class="question-list clearfix">
                    <ul class="question-list-ul margin-bottom-20">
                      <li v-for="item in queryList" v-if="item.title"><a target="_blank" :href="'/help/content_'+ item.id +'.html'">{{item.title}}</a></li>
                    </ul>
                    <el-pagination style="margin-bottom: 0" background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total">
                    </el-pagination>
                  </div>
                </div>

                <div v-show="selquestion === 'question'" class="order-add">
                  <span class="no-helpe-span">没找到需要的答案？</span>
                  <el-button type="primary" @click="steps = 'four'">提交工单</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="steps === 'four'">
          <div class="alert-warn">
            请尽量清晰详尽的描述您的问题，以便工作人员能够快速帮您解决问题！感谢您的配合！
            <br>
            域名打不开或者解析故障请提交域名类工单；域名备案相关信息请提交备案类工单
            <br>
            <a class="z-color-a a-underline-link" style="text-decoration: underline;" href="/help/content_1178.html" target="_blank">必看：三丰云虚拟主机和云服务器的服务范围</a>
          </div>
          <el-form :model="gongdanForm" :rules="gongdanrules" ref="gongdanForm" label-width="180px" class="gongdan-form" status-icon >
            <el-form-item label="问题所属类别：" prop="ptype">
              <el-radio-group v-model="gongdanForm.ptype" size="small">
                <el-radio-button label="云服务器"></el-radio-button>
                <el-radio-button label="网站备案"></el-radio-button>
                <el-radio-button label="域名"></el-radio-button>
                <el-radio-button label="虚拟主机"></el-radio-button>
                <el-radio-button label="账号与财务"></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="问题描述：" prop="describe">
              <el-input type="textarea" :rows="4" placeholder="请描述您的问题" v-model="gongdanForm.describe"></el-input>
            </el-form-item>
            <el-form-item v-show="gongdanForm.ptype === '虚拟主机'" label="FTP帐号：" prop="ip">
              <el-input v-model="gongdanForm.vhost"></el-input>
            </el-form-item>
            <el-form-item v-show="gongdanForm.ptype === '虚拟主机'" label="FTP密码：" prop="password">
              <el-input v-model="gongdanForm.vhost_psd"></el-input>
            </el-form-item>
            <el-form-item v-show="gongdanForm.ptype === '云服务器'" label="云服务器IP：" prop="ip">
              <el-input v-model="gongdanForm.vps"></el-input>
            </el-form-item>
            <el-form-item v-show="gongdanForm.ptype === '云服务器'" label="管理员密码：" prop="password">
              <el-input v-model="gongdanForm.vps_psd"></el-input>
            </el-form-item>
            <el-form-item v-show="gongdanForm.ptype === '域名'" label="域名：" prop="ip">
              <el-input v-model="gongdanForm.domain"></el-input>
            </el-form-item>
            <el-form-item label="附件上传：" prop="fujian">
              <div class="ub-box">
                <div class="ub-box">
                  <div class="col-img-container">
                    <span class="col-img" v-show="imgnum == 0">
                      <img  src="../../assets/imgs/img3.png" alt="请上传现场图片" width="135" height="102">
                    </span>
                    <span :class="{'attachment-uploading':imgnum == 1 && loadingImg,'attachment-done': dataUrl.length > 0}" class="col-img" v-show="imgnum>0">
                      <img  class="col-img-item" :src="dataUrl[0]" width="135" height="102"/>
                      <a class="delete-attachment default-transition z-textAlign-center" href="javascript:;" @click="delImg(0)">删除</a>
                    </span>
                    <span :class="{'attachment-uploading':imgnum == 2 && loadingImg,'attachment-done': dataUrl.length > 1}" class="col-img" v-show="imgnum>1">
                      <img  class="col-img-item" :src="dataUrl[1]" width="135" height="102"/>
                      <a class="delete-attachment default-transition z-textAlign-center" href="javascript:;" @click="delImg(1)">删除</a>
                    </span>
                    <span :class="{'attachment-uploading':imgnum == 3 && loadingImg,'attachment-done': dataUrl.length > 2}" class="col-img" v-show="imgnum>2">
                      <img class="col-img-item" :src="dataUrl[2]" width="135" height="102"/>
                      <a class="delete-attachment default-transition z-textAlign-center" href="javascript:;" @click="delImg(2)">删除</a>
                    </span>
                  </div>
                </div>
                <div class="z-margin-left-15-precent" v-show="imgnum < 3">
                  <p class="gff8 z-font-size-14">JPG或PNG格式</p>
                  <p class="z-font-size-12 z-color-999 z-padding-bottom-5-precent">最多可上传3个附件
                  </p>
                  <label for="fileImg1" class="choose-file">上传附件</label>
                  <input type="file" id="fileImg1" name="CertImg" @change="handleFileChange" ref="inputer" class="z-width-30-precent" style="visibility: hidden;">
                </div>
              </div>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="submitForm('gongdanForm')">确认工单信息，提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import helpService from 'business/helpService.js'
  import gongdanService from 'business/gongdanService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialogLoading:false,
        steps:'first',
        search:'',
        selquestion:'index',
        typeList:[],
        queryList:[],
        queryId:'',
        menuIndex:1000,
        gongdanForm:{
          ptype:'云服务器',
          describe:'',
          vhost:'',
          vps:'',
          domain:'',
          vhost_pad:'',
          vps_pad:'',
        },
        gongdanrules:{},
        dataUrl:[],
        imgnum:0,
        total:0,
        page:1,
        loadingImg:false,
        id_root:''
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {

    },
    methods:{
      ...mapActions(['SETTHREE_MENU']),
      async submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit()
          } else {
            return false;
          }
        });
      },
      async SearchQuery(){
        this.selquestion = 'question'
        this.steps = 'second'
        let data = 'cmd=query'+
          '&count=10'+
          '&page='+ this.page +
          '&keyword=' + this.search
        let {vueData, state} = await helpService.transformToVue('helpInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.queryList = vueData.msg.content
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async SelectHelp(id) {
        this.steps = 'second'
        let data = 'cmd=get_typelist'+
          '&type_id=' + id
        let {vueData, state} = await helpService.transformToVue('helpInfo','POST',data)
        if(state.code == '000' ) {
          this.typeList = vueData
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async SelectQuery(id,idx){
        this.menuIndex = idx
        this.queryId = id
        this.selquestion = 'question'
        this.steps = 'second'
        let data = 'cmd=query'+
          '&count=10'+
          '&page='+ this.page +
          '&type_id=' + id
        let {vueData, state} = await helpService.transformToVue('helpInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.queryList = vueData.msg.content
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SelectQuery(this.queryId,this.menuIndex)
      },
      async handleFileChange () {
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file  = inputDOM.files[0];


        /*this.imgPreview(this.file);*/

        if(this.file){
          this.imgnum = this.dataUrl.length +1
          this.loadingImg = true
          let formData = new window.FormData();
          formData.append('cmd', 'up_img')
          formData.append('gd_img', this.$refs.inputer.files[0])
          let {vueData, state} = await gongdanService.transformToVue('gdInfo','POST',formData)
          if(vueData.response == 200 ) {
            this.loadingImg = false
            this.dataUrl.push(vueData.img_url)
          }else {
            this.loadingImg = false
            this.$toast(vueData.msg,'fail')
          }
        }

      },
      delImg(id) {
        this.dataUrl.splice(id,1)
        this.imgnum = this.dataUrl.length
      },
      URLencode(sStr) {
        return sStr.replace(/\+/g, '%2B').replace(/\"/g,'%22').replace(/\'/g, '%27').replace(/\//g,'%2F');
      },
      async submit() {
        let data;
        switch (this.gongdanForm.ptype) {
          case '云服务器':
            data = 'cmd=gd_add'+
              '&gd_type=vps'+
              '&product_value='+ this.gongdanForm.vps +
              '&gd_content=' + this.URLencode(this.gongdanForm.describe) +
              '&gd_yw_pwd=' + this.gongdanForm.vps_psd +
              '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
              '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
              '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '')
            break
          case '网站备案':
            data = 'cmd=gd_add'+
              '&gd_type=beian'+
              '&gd_content=' + this.URLencode(this.gongdanForm.describe) +
              '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
              '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
              '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '')
            break
          case '域名':
            data = 'cmd=gd_add'+
              '&gd_type=domain'+
              '&product_value='+ this.gongdanForm.domain +
              '&gd_content=' + this.URLencode(this.gongdanForm.describe) +
              '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
              '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
              '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '')
            break
          case '虚拟主机':
            data = 'cmd=gd_add'+
              '&gd_type=vhost'+
              '&product_value='+ this.gongdanForm.vhost +
              '&gd_content=' + this.URLencode(this.gongdanForm.describe) +
              '&gd_yw_pwd=' + this.gongdanForm.vhost_psd +
              '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
              '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
              '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '')
            break
          case '账号与财务':
            data = 'cmd=gd_add'+
              '&gd_type=account'+
              '&gd_content=' + this.URLencode(this.gongdanForm.describe) +
              '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
              '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
              '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '')
            break
        }
        this.dialogLoading = true
        let {vueData, state} = await gongdanService.transformToVue('gdInfo','POST',data)
        if(vueData.response == 200 ) {
          this.id_root = vueData.id_root
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
            self.SETTHREE_MENU(1)
            self.$router.push('/fuwu3/'+ self.id_root)
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      }
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .input-with-select .el-input-group__prepend .el-select {
    width: 90px;
  }

  .gongdan-form .el-input,.el-select,.el-textarea {
    width: 440px;
  }
  .step-bar {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    float: left;
    width: 33%;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #fff;
  }
  /* 父容器添加，变为3或4或5个步骤，triple是3,quadra是4，penta是5*/
  .step-bar-triple .step-bar {
    width: 33.3%;
  }
  .step-bar-quadra .step-bar {
    width: 25%;
  }
  .step-bar-penta .step-bar {
    width: 20%;
  }
  .step-bar-begin {
    padding-right: 18px;
  }
  .step-bar-center {
    padding: 0 18px;
  }
  .step-bar-end {
    padding-left: 18px;
  }
  .step-colored {
    background-color: #7fddff;
  }
  /*.step-prefix {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -16px;
  }
  .step--current .step-prefix {
    background: url(img/uc/step_complete.png) no-repeat center;
    vertical-align: middle;
    !* 字体隐藏，由于模板中控制text-hide类比较复杂，这里使用step--current统一控制样式*!
    border: 0;
    background-color: transparent;
    color: transparent;
    font: 0/0 a;
    text-shadow: none;
  }
  .step--current.step--failed .step-prefix {
    background-image: url(img/uc/step_failed.png);
  }
  .step--current.step--dealing .step-prefix {
    background-image: url(img/uc/step_waiting.png);
  }*/
  .step--current .step-colored {
    background-color: #00aaff;
    color: #fff;
  }
  .step--completed .step-colored {
    background-color: #7fddff;
    color: #fff;
  }
  .step-arrow-left,
  .step-arrow-right {
    position: absolute;
    top: 0;
    border: 18px solid transparent;
    border-left-color: #7fddff;
  }
  .step-arrow-left {
    left: -8px;
    border: 18px solid #7fddff;
    border-left-color: transparent;
  }
  .step-arrow-right {
    right: -18px;
  }
  .step--current .step-arrow-left {
    border-color: #00aaff;
    border-left-color: transparent;
  }
  .step--current .step-arrow-right {
    border-left-color: #00aaff;
  }
  /* 对当前步骤之后的所有步骤设置灰色样式 */
  .step--current ~ .step-bar .step-colored {
    background-color: #f2f2f2;
    color: #636566;
  }
  .step--current ~ .step-bar .step-arrow-left {
    border-color: #f2f2f2;
    border-left-color: transparent;
  }
  .step--current ~ .step-bar .step-arrow-right {
    border-left-color: #f2f2f2;
  }
  /*选择问题类型*/
  .select-container-title {
    margin-bottom: 7px;
    color: #00aaff;
    line-height: 46px;
    font-size: 14px;
    font-weight: bold;
  }
  .select-item {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    float: left;
    margin-left: 2%;
    margin-bottom: 24px;
    border: 1px solid #e1e4e6;
    padding: 32px 16px 0 90px;
    height: 120px;
    width: 32%;
    cursor: pointer;
  }
  .select-item:nth-child(3n+1) {
    margin-left: 0;
  }
  .select-item:hover {
    text-decoration: none;
    border-color: #00aaff;

  }
  .select-item-icon {
    position: absolute;
    left: 20px;
    top: 31px;
    width: 51px;
    height: 56px;
    background: url(../../assets/imgs/select_icon_01.png) no-repeat 0 0;
  }
  .select-item-icon01 {
    background: url(../../assets/imgs/select_icon_01.png) no-repeat 0 0;
  }
  .select-item-icon02 {
    background: url(../../assets/imgs/select_icon_02.png) no-repeat 0 0;
  }
  .select-item-icon03 {
    background: url(../../assets/imgs/select_icon_03.png) no-repeat 0 0;
  }
  .select-item:hover .select-item-icon{
    background-position: -51px 0;
  }
  .select-item-title {
    margin-bottom: 0;
    line-height: 30px;
    font-size: 18px;
    color: #262829;
  }
  .select-item-intro {
    margin-bottom: 0;
    line-height: 22px;
    font-size: 12px;
    color: #a0a2a3;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  /*steps2*/
  .menu-box {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    display: inline-block;
    border: 1px solid #e1e4e6;
    width: 24%;
    /*background-color: #F5F9FA;*/
  }

  .menu-box-title {
    border-bottom: 1px solid #e1e4e6;
    padding-left: 10%;
    height: 41px;
    line-height: 40px;
    font-size: 14px;
    color: #636566;
    font-weight: bold;
    background: #f7f9fa;
  }
  .menu-box li {
    position: relative;
    border-bottom: 1px solid #e1e4e6;
    height: 40px;
    line-height: 40px;
    padding-left: 5%;
    margin: 0 5%;
    color: #333;
  }
  .menu-box li:last-child {
    border-bottom: none;
  }
  .fuwu-menu-item i {
    width: 0;
    height: 0;
    border-style: solid;
    _border-style: dotted;
    border-width: 4px;
    border-color: transparent transparent transparent #666;
    position: absolute;
    right: 0;
    top: 18px;
  }
  .fuwu-menu-item a {
    display: block;
    color: #333;
    margin-right: 15px;
    white-space: nowrap;
    overflow: hidden;
  }
  .fuwu-menu-item a:hover {
    text-decoration: none;
    color: #00aaff;
    cursor: pointer;
  }
  .menu-box li:hover {
    background-color: #fff;
  }
  .menu-box li:hover i {
    border-left-color: #00aaff;
  }

  li.menu-active {
    background-color: #fff;
  }
  li.menu-active a {
    color: #00aaff;
  }
  li.menu-active i {
    border-left-color: #00aaff;
  }

  .fuwu-menu-list {
    max-height: 693px;
    overflow: hidden;
  }
  .fuwu-menu-list.open li:last-child {
    border-bottom: 1px solid #e1e4e6;
  }
  .fuwu-menu-list.open {
    max-height: none;
    padding-bottom: 7px;
  }
  .content-box {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 22px;
    width: 76%;
    /*min-height: 693px;*/
  }

  .content-box-inner {
    height: 100%;
    border: 1px solid #e1e4e6;
  }
  .question-list-ul {
    /*min-height: 399px;*/
  }
  .search-box {
    display: block;
    position: relative;
    margin: 0 19px 15px;
    border-bottom: 1px solid #e1e4e6;
    padding-top: 16px;
    padding-left: 10px;
    height: 65px;
  }

  .fuzzy-query {
    display: none;
    position: absolute;
    left: 10px;
    top: 48px;
    width: 426px;
    border:1px solid #d6d6d6;
    border-top: none;
    background-color: #fff;
    z-index: 10;
  }
  .fuzzy-query li {
    padding-left: 14px;
    height: 30px;
    line-height: 30px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 12px;
    color: #666;
  }
  .fuzzy-query li:hover {
    background-color: #f0f0f0;
  }
  .fuzzy-query li span {
    color: #333;
  }
  .serach-container-wrapper {
    position: relative;
  }
  .serach-container-wrapper .fuzzy-query {
    z-index: 999;
    left: 0;
    top: 32px;
  }
  .question-box {
    padding: 0 30px;
  }
  .question-box {
    padding-bottom: 0;
  }
  .question-tip {
    font-size: 14px;
    line-height: 42px;
    color: #a0a2a3;
  }
  .question-list {
    display: block;
    padding-bottom: 30px;
  }

  .question-list.special {
    padding-bottom: 30px;
  }
  .question-list li {
    padding-left: 22px;
    height: 40px;
    line-height: 40px;
    background: url(../../assets/imgs/question_list_li_bg.png) no-repeat 0 center;
  }
  .question-list li:hover {
    background: url(../../assets/imgs/question_list_li_bg_active.png) no-repeat 0 center;
  }
  .question-list li a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: #666666;
  }
  .question-list li:hover a {
    color: #00aaff;
  }
  .no-helpe-span {
    font-size: 12px;
    color: #00aaff;
  }
  .btn-send-workorder {
    margin-left: 20px;
    width: 140px;
    text-align: center;
  }
  .order-add {
    margin: 0 19px;
    border-top: 1px solid #e1e4e6;
    padding: 30px 0;
    text-align: center;
  }
  .index-box {
    position: relative;
    width: 100%;
    height: 400px;
  }
  .index-box .index-panel{
    position: absolute;
    left: 20%;
    top: 20%;
    padding-left: 210px;
    padding-top: 40px;
    height: 287px;
    background: url(../../assets/imgs/certificate-bg.png) no-repeat left center;
  }
  .index-box p {
    line-height: 30px;
    font-size: 14px;
    color: #00aaff;
  }
  hr {
    margin-left: 20px;
  }
  .col-img-container .col-img {
    height: 102px;
  }
  .col-img {
    border: solid 1px #bbbaba;
    float: left;
    display: inline-block;
    overflow: hidden;
    position: relative;
    z-index: 1;
    margin-right: 10px;
  }
  .choose-file {
    display: inline-block;
    position: absolute;
    padding: 4px 12px;
    margin-bottom: 0;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
    border-color: #2082dd;
    background-color: #2a89e0;
    border-radius: 2px;
  }

  .attachment-uploading:after {
    background: #f5f5f5 url(../../assets/imgs/loading.gif) no-repeat center;
  }
  .attachment-uploading:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .delete-attachment{
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0;
    z-index: 110;
    height: 20px;
    line-height: 20px;
    color: #fff;
    background: #000;
    opacity: 0.5;
    filter: alpha(opacity=50);
  }
  .delete-attachment:hover {
    text-decoration: none;
    color: #fff;
    opacity: 0.7;
    filter: alpha(opacity=70);
  }
  .default-transition {
    -webkit-transition-duration: 0.3s;
    -moz-transition-duration: 0.3s;
    -ms-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: ease;
    -moz-transition-timing-function: ease;
    -ms-transition-timing-function: ease;
    -o-transition-timing-function: ease;
    transition-timing-function: ease;
  }
  .attachment-done:hover .delete-attachment {
    bottom: 0;
  }
  .attachment-uploading:hover .delete-attachment {
    bottom: -20px;
  }
  .attachment-uploading img {
    visibility: hidden;
  }
</style>




// WEBPACK FOOTER //
// src/pages/fuwu/fuwu1.vue